import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePageEight from "./pages/HomePageEight"; // Dashboard
import ErrorPage from "./pages/ErrorPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import PrivateRoute from "./helper/PrivateRoute";
import ProtectedRoute from "./helper/ProtectedRoute";
import { ToastContainer } from "react-toastify";

import EmployeeListPage from "./pages/EmployeeListPage";
import EmployeeFormPage from "./pages/EmployeeFormPage";
import EmployeeViewPage from "./pages/EmployeeViewPage";
import EmployeeEditPage from "./pages/EmployeeEditPage";

import ClientListPage from "./pages/ClientListPage";
import ExhibitorsPage from "./pages/ExhibitorsPage";
import UnwantedEnquiriesPage from "./pages/UnwantedEnquiriesPage";
import ClientFormPage from "./pages/ClientFormPage";
import ClientViewPage from "./pages/ClientViewPage";
import ClientGroupPage from "./pages/ClientGroupPage";
import ClientGroupViewPage from "./pages/ClientGroupViewPage";
import ParticipationHistoryPage from "./pages/ParticipationHistoryPage";

import FlashNewsPage from "./pages/FlashNewsPage";
import FlashNewsFormPage from "./pages/FlashNewsFormPage";

import ProductListPage from "./pages/ProductListPage";
import ProductFormPage from "./pages/ProductFormPage";

import ExpoListPage from "./pages/ExpoListPage";
import ExpoFormPage from "./pages/ExpoFormPage";
import ExpoViewPage from "./pages/ExpoViewPage";
import BookingStatusPage from "./pages/BookingStatusPage";
import PastExpoPage from "./pages/PastExpoPage";
import PresentExpoPage from "./pages/PresentExpoPage";
import PastExpoViewPage from "./pages/PastExpoViewPage";
import PastParticipantsPage from "./pages/PastParticipantsPage";
import UserLogPage from "./pages/UserLogPage";
import UserListPage from "./pages/UserListPage";
import TodayFollowupPage from "./pages/TodayFollowupPage";
import EventManagerReportPage from "./pages/EventManagerReportPage";
import EventManagerDetailsPage from "./pages/EventManagerDetailsPage";
import EventManagerBookingsPage from "./pages/EventManagerBookingsPage";
import EventManagerHistoryPage from "./pages/EventManagerHistoryPage";
import BackEndReportPage from "./pages/BackEndReportPage";
import ClientDataEntryPage from "./pages/ClientDataEntryPage";
import ClientDataEntryDetailsPage from "./pages/ClientDataEntryDetailsPage";
import EnquiryListPage from "./pages/EnquiryListPage";
import BookedReportPage from "./pages/BookedReportPage";
import AssignedPage from "./pages/AssignedPage";
import ProspectsPage from "./pages/ProspectsPage";
import CorrectionPage from "./pages/CorrectionPage";
import NotInterestPage from "./pages/NotInterestPage";
import OverDuePage from "./pages/OverDuePage";
import BookedDetailPage from "./pages/BookedDetailPage";
import AddEnquiryPage from "./pages/AddEnquiryPage";
import ExhibitionLayoutPage from "./pages/ExhibitionLayoutPage";
import VisitorEnquiryPage from "./pages/VisitorEnquiryPage";
import VisitorBookedPage from "./pages/VisitorBookedPage";
import VisitorReportsPage from "./pages/VisitorReportsPage";
import IdCardPage from "./pages/IdCardPage";
import VisitorBookingListPage from "./pages/VisitorBookingListPage";
import StallBookingListPage from "./pages/StallBookingListPage";
import PaymentReportPage from "./pages/PaymentReportPage";
import LocationPage from "./pages/LocationPage";
import GeneralReportPage from "./pages/GeneralReportPage";
import FeedbackPage from "./pages/Feedback";
import RoleListPage from "./pages/RoleListPage";
import RoleFormPage from "./pages/RoleFormPage";
import CategoryPage from "./pages/CategoryPage";
import StallTypePage from "./pages/StallTypePage";
import KnownSourcePage from "./pages/KnownSourcePage";
import TestimonialPage from "./pages/TestimonialPage";
import PastExpoGalleryPage from "./pages/PastExpoGalleryPage";
import ExpoBrandPage from "./pages/ExpoBrandPage";
import InterestListPage from "./pages/InterestListPage";
import BannerPage from "./pages/BannerPage";
import AdPage from "./pages/AdPage";
import CareerPage from "./pages/CareerPage";
import CareerFormPage from "./pages/CareerFormPage";
import CareerEnquiryPage from "./pages/CareerEnquiryPage";
import ContactUsPage from "./pages/ContactUsPage";
import ProfileCorrectionsPage from "./pages/ProfileCorrectionsPage";
import RefundListPage from "./pages/RefundListPage";


function App() {

  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <ToastContainer />
      <Routes>
        <Route exact path="/sign-in" element={<SignInPage />} />
        <Route exact path="/sign-up" element={<SignUpPage />} />
        <Route exact path="/forgot-password" element={<ForgotPasswordPage />} />

        {/* Protected Routes */}
        <Route element={<PrivateRoute />}>
          <Route exact path="/" element={<ProtectedRoute requiredPermission="Dashboard"><HomePageEight /></ProtectedRoute>} />

          <Route exact path="/employees" element={<ProtectedRoute requiredPermission="Managers"><EmployeeListPage /></ProtectedRoute>} />
          <Route exact path="/employees/add" element={<ProtectedRoute requiredPermission="Managers"><EmployeeFormPage /></ProtectedRoute>} />
          <Route exact path="/employees/view/:id" element={<ProtectedRoute requiredPermission="Managers"><EmployeeViewPage /></ProtectedRoute>} />
          <Route exact path="/employees/edit/:id" element={<ProtectedRoute requiredPermission="Managers"><EmployeeEditPage /></ProtectedRoute>} />

          {/* Clients */}
          <Route exact path="/clients" element={<ProtectedRoute requiredPermission="Clients"><ClientListPage /></ProtectedRoute>} />
          <Route exact path="/exhibitors" element={<ProtectedRoute requiredPermission="Clients"><ExhibitorsPage /></ProtectedRoute>} />
          <Route exact path="/unwanted-enquiries" element={<ProtectedRoute requiredPermission="Unwanted Enquiries"><UnwantedEnquiriesPage /></ProtectedRoute>} />
          <Route exact path="/clients/add" element={<ProtectedRoute requiredPermission="Clients"><ClientFormPage /></ProtectedRoute>} />
          <Route exact path="/clients/edit/:id" element={<ProtectedRoute requiredPermission="Clients"><ClientFormPage /></ProtectedRoute>} />
          <Route exact path="/clients/view/:id" element={<ProtectedRoute requiredPermission="Clients"><ClientViewPage /></ProtectedRoute>} />
          <Route exact path="/clients/participation/:id" element={<ProtectedRoute requiredPermission="Clients"><ParticipationHistoryPage /></ProtectedRoute>} />
          <Route exact path="/client-groups" element={<ProtectedRoute requiredPermission="Exhibitors"><ClientGroupPage /></ProtectedRoute>} />
          <Route exact path="/client-groups/view/:id" element={<ProtectedRoute requiredPermission="Exhibitors"><ClientGroupViewPage /></ProtectedRoute>} />

          {/* Announcement */}
          <Route exact path="/flash-news" element={<ProtectedRoute requiredPermission="Flash News"><FlashNewsPage /></ProtectedRoute>} />
          <Route exact path="/flash-news/add" element={<ProtectedRoute requiredPermission="Flash News"><FlashNewsFormPage /></ProtectedRoute>} />
          <Route exact path="/flash-news/edit/:id" element={<ProtectedRoute requiredPermission="Flash News"><FlashNewsFormPage /></ProtectedRoute>} />
          {/* Banner Ads */}
          <Route exact path="/banners" element={<ProtectedRoute requiredPermission="Banner Ads"><BannerPage /></ProtectedRoute>} />
          <Route exact path="/ads" element={<ProtectedRoute requiredPermission="Banner Ads"><AdPage /></ProtectedRoute>} />

          <Route exact path="/interest-list" element={<ProtectedRoute requiredPermission="Website Enquiries"><InterestListPage /></ProtectedRoute>} />
          {/* Products */}
          <Route exact path="/products" element={<ProtectedRoute requiredPermission="Products"><ProductListPage /></ProtectedRoute>} />
          <Route exact path="/products/add" element={<ProtectedRoute requiredPermission="Products"><ProductFormPage /></ProtectedRoute>} />
          <Route exact path="/products/edit/:id" element={<ProtectedRoute requiredPermission="Products"><ProductFormPage /></ProtectedRoute>} />

          {/* Categories */}
          <Route exact path="/categories" element={<ProtectedRoute requiredPermission="Category"><CategoryPage /></ProtectedRoute>} />

          {/* Location */}
          <Route exact path="/location" element={<ProtectedRoute requiredPermission="Location"><LocationPage /></ProtectedRoute>} />

          {/* Stall Type */}
          <Route exact path="/stall-type" element={<ProtectedRoute requiredPermission="Stall Type"><StallTypePage /></ProtectedRoute>} />

          {/* Source (Known Source) */}
          <Route exact path="/sources" element={<ProtectedRoute requiredPermission="Source"><KnownSourcePage /></ProtectedRoute>} />

          {/* Testimonials */}
          <Route exact path="/testimonials" element={<ProtectedRoute requiredPermission="Testimonials"><TestimonialPage /></ProtectedRoute>} />

          {/* Website / Expo */}
          <Route exact path="/upcoming-expo" element={<ProtectedRoute requiredPermission="Upcoming Expo"><ExpoListPage /></ProtectedRoute>} />
          <Route exact path="/upcoming-expo/add" element={<ProtectedRoute requiredPermission="Upcoming Expo"><ExpoFormPage /></ProtectedRoute>} />
          <Route exact path="/upcoming-expo/edit/:id" element={<ProtectedRoute requiredPermission="Upcoming Expo"><ExpoFormPage /></ProtectedRoute>} />
          <Route exact path="/upcoming-expo/exhibition-layout/:id" element={<ProtectedRoute requiredPermission="Upcoming Expo"><ExhibitionLayoutPage /></ProtectedRoute>} />
          <Route exact path="/upcoming-expo/view/:id" element={<ProtectedRoute requiredPermission="Upcoming Expo"><ExpoViewPage /></ProtectedRoute>} />
          <Route exact path="/upcoming-expo/view/:id/add-enquiry" element={<ProtectedRoute requiredPermission="Upcoming Expo"><AddEnquiryPage /></ProtectedRoute>} />

          <Route exact path="/booking-status" element={<ProtectedRoute requiredPermission="Stall Booking List"><BookingStatusPage /></ProtectedRoute>} />
          <Route exact path="/past-expo" element={<ProtectedRoute requiredPermission="Past Expo"><PastExpoPage /></ProtectedRoute>} />
          <Route exact path="/past-expo/view/:id" element={<ProtectedRoute requiredPermission="Past Expo"><PastExpoViewPage /></ProtectedRoute>} />
          <Route exact path="/past-expo/gallery/:id" element={<ProtectedRoute requiredPermission="Past Expo"><PastExpoGalleryPage /></ProtectedRoute>} />
          <Route exact path="/past-expo/expo-brands" element={<ProtectedRoute requiredPermission="Past Expo"><ExpoBrandPage /></ProtectedRoute>} />
          <Route exact path="/present-expo" element={<ProtectedRoute requiredPermission="Current Expo"><PresentExpoPage /></ProtectedRoute>} />
          <Route exact path="/past-participants" element={<ProtectedRoute requiredPermission="Past Expo"><PastParticipantsPage /></ProtectedRoute>} />
          <Route exact path="/user-log" element={<ProtectedRoute requiredPermission="User Log"><UserLogPage /></ProtectedRoute>} />
          <Route exact path="/user-list" element={<ProtectedRoute requiredPermission="User List"><UserListPage /></ProtectedRoute>} />
          <Route exact path="/today-followup" element={<ProtectedRoute requiredPermission="Today Followup"><TodayFollowupPage /></ProtectedRoute>} />
          <Route exact path="/generate-id" element={<ProtectedRoute requiredPermission="ID Card Generator"><IdCardPage /></ProtectedRoute>} />
          <Route exact path="/visitor-booking-list" element={<ProtectedRoute requiredPermission="Visitor Booking List"><VisitorBookingListPage /></ProtectedRoute>} />
          <Route exact path="/stall-booking-list" element={<ProtectedRoute requiredPermission="Stall Booking List"><StallBookingListPage /></ProtectedRoute>} />
          <Route exact path="/reports/payment" element={<ProtectedRoute requiredPermission="Payment Report"><PaymentReportPage /></ProtectedRoute>} />
          <Route exact path="/feedback" element={<ProtectedRoute requiredPermission="Feedback"><FeedbackPage /></ProtectedRoute>} />
          <Route exact path="/careers" element={<ProtectedRoute requiredPermission="Careers"><CareerPage /></ProtectedRoute>} />
          <Route exact path="/careers/add" element={<ProtectedRoute requiredPermission="Careers"><CareerFormPage /></ProtectedRoute>} />
          <Route exact path="/careers/edit/:id" element={<ProtectedRoute requiredPermission="Careers"><CareerFormPage /></ProtectedRoute>} />
          <Route exact path="/careers/enquiries/:id" element={<ProtectedRoute requiredPermission="Careers"><CareerEnquiryPage /></ProtectedRoute>} />
          <Route exact path="/contact-us" element={<ProtectedRoute requiredPermission="Contact Us"><ContactUsPage /></ProtectedRoute>} />

          <Route exact path="/reports/event-manager" element={<ProtectedRoute requiredPermission="Event Manager Report"><EventManagerReportPage /></ProtectedRoute>} />
          <Route exact path="/reports/event-manager/view/:id" element={<ProtectedRoute requiredPermission="Event Manager Report"><EventManagerDetailsPage /></ProtectedRoute>} />
          <Route exact path="/reports/event-manager/view/:id/bookings/:expoId" element={<ProtectedRoute requiredPermission="Event Manager Report"><EventManagerBookingsPage /></ProtectedRoute>} />
          <Route exact path="/reports/event-manager/history/:id" element={<ProtectedRoute requiredPermission="Event Manager Report"><EventManagerHistoryPage /></ProtectedRoute>} />
          <Route exact path="/reports/back-end" element={<ProtectedRoute requiredPermission="Report"><BackEndReportPage /></ProtectedRoute>} />
          <Route exact path="/reports/client-data-entry" element={<ProtectedRoute requiredPermission="Report"><ClientDataEntryPage /></ProtectedRoute>} />
          <Route exact path="/reports/client-data-entry/view/:id" element={<ProtectedRoute requiredPermission="Report"><ClientDataEntryDetailsPage /></ProtectedRoute>} />
          <Route exact path="/reports/booked" element={<ProtectedRoute requiredPermission="Report"><BookedReportPage /></ProtectedRoute>} />
          <Route exact path="/reports" element={<ProtectedRoute requiredPermission="Report"><GeneralReportPage /></ProtectedRoute>} />
          <Route exact path="/enquiry-list" element={<ProtectedRoute requiredPermission="Report"><EnquiryListPage /></ProtectedRoute>} />

          <Route exact path="/assigned" element={<ProtectedRoute requiredPermission="Clients"><AssignedPage /></ProtectedRoute>} />
          <Route exact path="/prospects" element={<ProtectedRoute requiredPermission="Clients"><ProspectsPage /></ProtectedRoute>} />
          <Route exact path="/correction" element={<ProtectedRoute requiredPermission="Clients"><CorrectionPage /></ProtectedRoute>} />
          <Route exact path="/not-interest" element={<ProtectedRoute requiredPermission="Clients"><NotInterestPage /></ProtectedRoute>} />
          <Route exact path="/over-due" element={<ProtectedRoute requiredPermission="Clients"><OverDuePage /></ProtectedRoute>} />
          <Route exact path="/booked-details" element={<ProtectedRoute requiredPermission="Clients"><BookedDetailPage /></ProtectedRoute>} />
          <Route exact path="/exhibition-layout" element={<ProtectedRoute requiredPermission="Upcoming Expo"><ExhibitionLayoutPage /></ProtectedRoute>} />
          <Route exact path="/visitor-enquiry" element={<ProtectedRoute requiredPermission="Current Expo"><VisitorEnquiryPage /></ProtectedRoute>} />
          <Route exact path="/visitor-booked" element={<ProtectedRoute requiredPermission="Current Expo"><VisitorBookedPage /></ProtectedRoute>} />
          <Route exact path="/visitor-reports" element={<ProtectedRoute requiredPermission="Current Expo"><VisitorReportsPage /></ProtectedRoute>} />

          {/* Roles */}
          <Route exact path="/roles" element={<ProtectedRoute requiredPermission="User Roles"><RoleListPage /></ProtectedRoute>} />
          <Route exact path="/roles/add" element={<ProtectedRoute requiredPermission="User Roles"><RoleFormPage /></ProtectedRoute>} />
          <Route exact path="/roles/edit/:id" element={<ProtectedRoute requiredPermission="User Roles"><RoleFormPage /></ProtectedRoute>} />

          {/* Profile Correction Requests */}
          <Route exact path="/profile-corrections" element={<ProtectedRoute requiredPermission="Support"><ProfileCorrectionsPage /></ProtectedRoute>} />
          <Route exact path="/refund-list" element={<ProtectedRoute requiredPermission="Refund List"><RefundListPage /></ProtectedRoute>} />

          <Route exact path="*" element={<ErrorPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
